import { Grid, Box, Stack, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { memo, useContext } from 'react';
import { EditableContext } from '../../contexts/EditableContext';

type Props = { onClick: () => void; label?: string; xs?: number; disabled?: boolean };

const CreatePlaceholderButton = memo(({ onClick, label='Create Placeholder', xs=2, disabled=false }: Props) => {
  const isEditable = useContext(EditableContext);

  return (!isEditable ? <></> :
    <Grid item xs={xs}>
      <Box display="flex" justifyContent="flex-end" className="tools">
        <Stack spacing={2} direction="row">
          <Button variant="contained" color="secondary" onClick={onClick} disabled={disabled} startIcon={<AddIcon />}>
            {label}
          </Button>
        </Stack>
      </Box>
    </Grid>
  );
});

export default CreatePlaceholderButton;